import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CSPMigrationToNCE } from '../../models/csp.model';
import { AnnuityViewModel } from '../../models/annuity-view.model';
import { CommonService } from '../../services';
import { ManageService } from '../../services/manage.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';

@Component({
  selector: 'migrate-to-nce-qty',
  templateUrl: './migrate-to-nce.component.html',
  styleUrls: ['./migrate-to-nce.component.css']
})
export class MigrateToNCEComponent implements OnInit {

  ngUnsubscribe: Subject<void> = new Subject<void>();

  public loading = false;

  public needRefresh = true;

  public resultMsg: string;

  public annuity: AnnuityViewModel;

  public migrateToNCEForm = this.fb.group({
    term: ['', Validators.required],
    billingCycle: ['', Validators.required]
  });

  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<MigrateToNCEComponent>,
    private fb: FormBuilder,
    private ms: ManageService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data.annuity) {
      this.annuity = this.data.annuity;
    }
  }

  onNoClick(): void {
    this.dialogRef.close({action: 'Close'});
  }

  public confirm(): void {
    if (this.resultMsg) {
      if (this.needRefresh) {
        this.dialogRef.close({action: 'Close'});
      }
      this.dialogRef.close({action: 'CloseAndRefresh'});
    } else {
      const cspMigrationToNCE = {
        term: this.migrateToNCEForm.get('term').value ? this.migrateToNCEForm.get('term').value : null,
        billingCycle: this.migrateToNCEForm.get('billingCycle').value ? this.migrateToNCEForm.get('billingCycle').value : null,
        tenantId: (this.annuity && this.annuity.annuityId) ? this.annuity.annuityId : null,
        migrateAllTenants:  (this.annuity && this.annuity.annuityId) ? false : true
      } as CSPMigrationToNCE;
  
      this.loading = true
      this.ms.MigrationToNCE(cspMigrationToNCE)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: ApiResponse) => {
          this.loading = false;
          this.resultMsg = res.responseMessage;
          if (!res.status) {
            this.needRefresh = false; 
          }
        });
    }
  }


  /**
   *  if the term is selecing monthly, we set billing cycle to only monthly and disable it
   */
  public checkIfYearly(event): void {
    if (event.value === "P1M") {
      this.migrateToNCEForm.get('billingCycle').setValue('monthly');
      this.migrateToNCEForm.get('billingCycle').disable();
    } else {
      this.migrateToNCEForm.get('billingCycle').enable();
    }
  }
}
